export const AIDA_COMPANY_TYPE_OPTIONS = [
  { value: "oem_constructeur", label: "OEM / Constructeur" },
  { value: "fabricant_pieces_rechange", label: "Fabricant pieces de rechange" },
  { value: "fabricant_local", label: "Fabricant local" },
  { value: "equipementier", label: "Equipementier" },
  { value: "sous_traitant_industriel", label: "Sous-traitant industriel" },
  { value: "fournisseur_matiere_premiere", label: "Fournisseur matiere premiere" },
  { value: "startup_industrielle_digitale", label: "Startup industrielle / digitale" },
  { value: "pme_micro_a_qualifier", label: "PME / Micro-entreprise a qualifier" },
  { value: "multinational", label: "Multinational" },
  { value: "investisseur", label: "Investisseur" },
  { value: "hors_perimetre_importateur", label: "Hors perimetre AIDA - Importateur / Distributeur" },
];

export const AIDA_CATEGORY_OPTIONS = [
  { value: "oem_constructeur", label: "OEM / Constructeur" },
  { value: "fabricant_local", label: "Fabricant local" },
  { value: "equipementier", label: "Equipementier" },
  { value: "sous_traitant_industriel", label: "Sous-traitant industriel" },
  { value: "fournisseur_matiere_premiere", label: "Fournisseur matiere premiere" },
  { value: "startup_industrielle_digitale", label: "Startup industrielle / digitale" },
  { value: "pme_a_qualifier", label: "PME / Micro-entreprise a qualifier" },
  { value: "investisseur", label: "Investisseur" },
  { value: "hors_perimetre_importateur", label: "Hors perimetre AIDA - Importateur / Distributeur" },
];

export const AIDA_STATUS_OPTIONS = [
  { value: "inscrit", label: "Inscrit" },
  { value: "verifie", label: "Verifie" },
  { value: "confirme", label: "Confirme" },
  { value: "rfq_ready", label: "RFQ Ready" },
  { value: "oem_supplier", label: "OEM Supplier" },
  { value: "hors_perimetre", label: "Hors perimetre AIDA" },
];

export const AIDA_BADGE_OPTIONS = [
  { value: "aida_verified", label: "AIDA Verified" },
  { value: "fabricant_local_confirme", label: "Fabricant local confirme" },
  { value: "equipementier_verifie", label: "Equipementier verifie" },
  { value: "sous_traitant_industriel", label: "Sous-traitant industriel" },
  { value: "matiere_premiere_verifiee", label: "Matiere premiere verifiee" },
  { value: "startup_industrielle", label: "Startup industrielle" },
  { value: "rfq_ready", label: "RFQ Ready" },
  { value: "oem_supplier", label: "OEM Supplier" },
  { value: "investisseur_partenaire", label: "Investisseur partenaire" },
  { value: "a_qualifier", label: "A qualifier" },
];

export const AIDA_CLASSIFICATION_NOTICE =
  "AIDA distingue les acteurs industriels selon leur role reel dans la chaine de valeur : constructeurs, fabricants locaux, equipementiers, sous-traitants industriels, fournisseurs de matieres premieres, startups technologiques, PME a qualifier et investisseurs. Les importateurs et distributeurs simples sont exclus de la cartographie industrielle afin de preserver la fiabilite et la credibilite de la plateforme.";

export const getAidaOptionLabel = (
  options: { value: string; label: string }[],
  value?: string | null,
) => {
  if (!value) return "-";
  return options.find((option) => option.value === value)?.label || value;
};
